const Flag = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M2 2V22.0007"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M2 3.33301H21.334C21.4625 3.33314 21.5881 3.37038 21.6959 3.44023C21.8037 3.51008 21.889 3.60958 21.9416 3.72676C21.9942 3.84394 22.0118 3.97381 21.9923 4.10077C21.9728 4.22772 21.9171 4.34634 21.8318 4.44238L18.2717 8.4443C18.0545 8.68843 17.9345 9.0038 17.9345 9.33055C17.9345 9.6573 18.0545 9.97268 18.2717 10.2168L21.8274 14.2214C21.9127 14.3174 21.9684 14.4361 21.9879 14.563C22.0073 14.69 21.9897 14.8198 21.9371 14.937C21.8845 15.0542 21.7992 15.1537 21.6915 15.2235C21.5837 15.2934 21.458 15.3306 21.3296 15.3308H2"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Flag;
